import { isValidPublicKey } from './validation/solana';
export const shortenAddress = (pubkey) => {
    if (!isValidPublicKey(pubkey)) {
        return '';
    }
    return `${pubkey.slice(0, 4)}...${pubkey.slice(-4)}`;
};
export const lamportsToSol = (lamports) => lamports / 10 ** 9;
